import { JSX, ReactNode, Suspense } from "react";

import CssBaseline from "@mui/material/CssBaseline";
import LinearProgress from "@mui/material/LinearProgress";
import { CadClickUiControlsScriptUrlContext } from "@plansoft-configuration-renderer/components";

interface MinimalAppContextProps {
  children: ReactNode;
}

export function MinimalAppContext(props: MinimalAppContextProps): JSX.Element {
  return (
    <>
      <CssBaseline />
      <CadClickUiControlsScriptUrlContext.Provider value="kim-viewer-3d/uicontrols.iife.2.8.1.min.js">
        <Suspense fallback={<LinearProgress />}>{props.children}</Suspense>
      </CadClickUiControlsScriptUrlContext.Provider>
    </>
  );
}
